const main = () => {
    if (document.querySelector('#page-favorite-index') == null) return;

    document.querySelectorAll('select[name="sort"]').forEach((obj) => {
        obj.addEventListener('change', (e) => {
            document.querySelector('#cond-edit').submit();
        });
    });
};

export default main;